import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["typeSelect", "frame"];

  typeChanged() {
    const assignableType = this.typeSelectTarget.value;
    const url = new URL(window.location.href);

    if (assignableType) {
      url.searchParams.set("assignable_type", assignableType);
    } else {
      url.searchParams.delete("assignable_type");
    }
    url.searchParams.delete("assignable_id");

    console.log("Navigating to:", url.toString());

    // Navigate the turbo frame
    this.frameTarget.src = url.toString();
  }
}
